<template>
  <b-card v-show="!hide" class="search-result">
    <div
      class="search-result"
      :class="{
        'search-result-ib': result._source.DutyType === 'IB',
        'search-result-dp': result._source.DutyType === 'DP',
      }"
    >
      <b-row no-gutter>
        <b-col cols="4" md="3" lg="2" class="text-center">
          <div
            :class="{
              'product-image': true,
              'on-offer': result._source.Promotion,
            }"
          >
            <a :href="result._source.Permalink"
              ><b-img-lazy
                :src="
                  result._source.Images &&
                  result._source.Images.length > 0 &&
                  result._source.Images[0]
                    ? result._source.Images[0]
                    : '/app/themes/jeroboams-2020/resources/assets/images/product-placeholder-low.png'
                "
                fluid
                :alt="result._source.ItemDescription[0]"
              ></b-img-lazy
            ></a>
          </div>
        </b-col>
        <b-col cols="8" md="9" lg="10">
          <b-badge
            v-if="result._source.StatusLabels['Recommended']"
            class="float-right"
            variant="success"
            >Recommended</b-badge
          >
          <wishlist-add-button
            v-if="isLoggedIn"
            class="float-right d-none d-md-block"
            :result="result"
          ></wishlist-add-button>

          <h5>
            <a :href="result._source.Permalink">
              {{ result._source.ItemDescription[0] }}
            </a>
          </h5>

          <wishlist-add-button
            v-if="isLoggedIn"
            class="d-md-none mb-1"
            :result="result"
          ></wishlist-add-button>

          <!-- <div
            class="product-stock-level low-stock mb-2"
            v-if="
              result._source.StockLevel === 0 &&
              result._source.StockStatus === 'Stock'
            "
          >
            Sold Out
          </div> -->

          <!-- <div
            class="product-stock-level low-stock mb-2"
            v-else-if="
              result._source.StockLevel < 20 &&
              result._source.StockStatus === 'Stock'
            "
          >
            {{ result._source.StockLevel }} left in stock
          </div> -->

          <div
            class="product-description mb-2"
            v-html="
              $options.filters.truncate(result._source.ProductDescription, 280)
            "
          ></div>

          <div
            class="mixed-case-parents mb-2"
            v-if="result._source.ParentCases || result._source.Promotions"
          >
            <div
              v-for="(parentCase, index) in result._source.ParentCases"
              :key="index"
              class="mixed-case-label d-inline"
            >
              <a :href="parentCase.url">{{ parentCase.name }}</a>
            </div>

            <div
              v-for="(promotion, index) in result._source.Promotions"
              :key="index"
              class="mixed-case-label d-inline"
              :style="{
                color: promotion.fg,
                backgroundColor: promotion.bg,
              }"
            >
              <a :href="promotion.url" :style="{ color: promotion.fg }">{{
                promotion.text
              }}</a>
            </div>
          </div>

          <div class="product-quick-info mb-1 d-none d-lg-block">
            <div
              class="product-hierarchy float-left"
              v-if="result._source.MixedCaseType === ''"
            >
              <a
                v-if="result._source.Country[0]"
                @click="
                  searchForFilterOnly('Country', result._source.Country[0])
                "
                >{{ result._source.Country[0] }}</a
              >
              <a
                v-if="result._source.Region[0]"
                @click="searchForFilterOnly('Region', result._source.Region[0])"
                >{{ result._source.Region[0] }}</a
              >
              <a
                v-if="result._source.SubRegion[0]"
                @click="
                  searchForFilterOnly('SubRegion', result._source.SubRegion[0])
                "
                >{{ result._source.SubRegion[0] }}</a
              >
            </div>

            <div class="product-hierarchy float-left" v-else>Mixed Case</div>

            <div
              class="product-key-info float-right"
              v-if="result._source.MixedCaseType === ''"
            >
              <div
                class="product-colour"
                :class="{
                  'colour-red': result._source.Colour[0] === 'Red',
                  'colour-white': result._source.Colour[0] === 'White',
                  'colour-rose': result._source.Colour[0] === 'Rose',
                  'colour-spirit': result._source.Colour[0] === 'Spirit',
                  'colour-beer': result._source.Colour[0] === 'Beer',
                  'colour-cider': result._source.Colour[0] === 'Cider',
                }"
              >
                <svg
                  class="bi"
                  width="1rem"
                  height="1rem"
                  fill="currentColor"
                  v-if="
                    result._source.Colour[0] === 'Red' ||
                    result._source.Colour[0] === 'White' ||
                    result._source.Colour[0] === 'Rose'
                  "
                >
                  <use
                    xlink:href="/app/themes/jeroboams-2020/resources/assets/images/wine-glass-alt.svg#wine"
                  />
                </svg>
                <svg
                  class="bi"
                  width="1rem"
                  height="1rem"
                  fill="currentColor"
                  v-if="result._source.Colour[0] === 'Beer'"
                >
                  <use
                    xlink:href="/app/themes/jeroboams-2020/resources/assets/images/beer.svg#beer"
                  />
                </svg>
                <svg
                  class="bi"
                  width="1rem"
                  height="1rem"
                  fill="currentColor"
                  v-if="result._source.Colour[0] === 'Spirit'"
                >
                  <use
                    xlink:href="/app/themes/jeroboams-2020/resources/assets/images/wine-bottle.svg#wine-bottle"
                  />
                </svg>
                <svg
                  class="bi"
                  width="1rem"
                  height="1rem"
                  fill="currentColor"
                  v-if="result._source.Colour[0] === 'Cider'"
                >
                  <use
                    xlink:href="/app/themes/jeroboams-2020/resources/assets/images/apple-alt.svg#apple"
                  />
                </svg>

                <span v-if="result._source.Colour[0] === 'Beer'">
                  {{ result._source.Type }}</span
                >
                <span v-else-if="result._source.Colour[0] === 'Spirit'">
                  {{ result._source.Type }}</span
                >
                <span v-else>
                  {{ result._source.Colour[0] }}
                </span>
              </div>
            </div>
          </div>

          <div class="product-prices d-none d-lg-block">
            <product-format
              :product="result"
              v-if="result._source.DutyAvail !== 'IBOnly'"
            ></product-format>
            <div
              class="product-only-inbond"
              v-if="
                result._source.DutyAvail === 'IBOnly' &&
                result._source.DutyType !== 'DP'
              "
            >
              <a :href="result._source.Permalink">Only available In Bond</a>
            </div>

            <div
              class="mt-1"
              v-if="
                result._source.OtherFormats.length > 0 &&
                !(!formatsLoading && formats[result._id])
              "
            >
              <b-link
                class="small"
                v-if="result._source.OtherFormats.length > 0"
                v-show="!(!formatsLoading && formats[result._id])"
                @click="toggleFormats(result)"
                >{{ result._source.OtherFormats.length }} other
                {{ "option" | inflect(result._source.OtherFormats.length) }}
                available
                <svg
                  v-if="formatsLoading && formats[result._id] === false"
                  class="bi ml-1 spin"
                  width="1rem"
                  height="1rem"
                  fill="currentColor"
                >
                  <use
                    xlink:href="/app/themes/jeroboams-2020/node_modules/bootstrap-icons/bootstrap-icons.svg#arrow-repeat"
                  />
                </svg>
              </b-link>
            </div>

            <div v-if="!formatsLoading && formats[result._id]" class="mt-1">
              <product-format
                v-for="format in formats[result._id]"
                v-bind:key="format._id"
                :product="format"
              >
              </product-format>
            </div>
          </div>
        </b-col>
        <b-col class="d-lg-none" size="12" lg="10" offset-lg="2">
          <div class="product-quick-info mb-1">
            <div
              class="product-hierarchy float-left"
              v-if="result._source.MixedCaseType === ''"
            >
              <a
                v-if="result._source.Country[0]"
                @click="
                  $emit('set-filter', {
                    field: 'Country',
                    term: result._source.Country[0],
                  })
                "
                >{{ result._source.Country[0] }}</a
              >
              <a
                v-if="result._source.Region[0]"
                @click="
                  $emit('set-filter', {
                    field: 'Region',
                    term: result._source.Region[0],
                  })
                "
                >{{ result._source.Region[0] }}</a
              >
              <a
                v-if="result._source.SubRegion[0]"
                @click="
                  $emit('set-filter', {
                    field: 'SubRegion',
                    term: result._source.SubRegion[0],
                  })
                "
                >{{ result._source.SubRegion[0] }}</a
              >
            </div>

            <div class="product-hierarchy float-left" v-else>Mixed Case</div>

            <div
              class="product-key-info float-right"
              v-if="result._source.MixedCaseType === ''"
            >
              <div
                class="product-colour"
                :class="{
                  'colour-red': result._source.Colour[0] === 'Red',
                  'colour-white': result._source.Colour[0] === 'White',
                  'colour-rose': result._source.Colour[0] === 'Rose',
                  'colour-spirit': result._source.Colour[0] === 'Spirit',
                  'colour-beer': result._source.Colour[0] === 'Beer',
                  'colour-cider': result._source.Colour[0] === 'Cider',
                }"
              >
                <svg
                  class="bi"
                  width="1rem"
                  height="1rem"
                  fill="currentColor"
                  v-if="
                    result._source.Colour[0] === 'Red' ||
                    result._source.Colour[0] === 'White' ||
                    result._source.Colour[0] === 'Rose'
                  "
                >
                  <use
                    xlink:href="/app/themes/jeroboams-2020/resources/assets/images/wine-glass-alt.svg#wine"
                  />
                </svg>
                <svg
                  class="bi"
                  width="1rem"
                  height="1rem"
                  fill="currentColor"
                  v-if="result._source.Colour[0] === 'Beer'"
                >
                  <use
                    xlink:href="/app/themes/jeroboams-2020/resources/assets/images/beer.svg#beer"
                  />
                </svg>
                <svg
                  class="bi"
                  width="1rem"
                  height="1rem"
                  fill="currentColor"
                  v-if="result._source.Colour[0] === 'Spirit'"
                >
                  <use
                    xlink:href="/app/themes/jeroboams-2020/resources/assets/images/wine-bottle.svg#wine-bottle"
                  />
                </svg>
                <svg
                  class="bi"
                  width="1rem"
                  height="1rem"
                  fill="currentColor"
                  v-if="result._source.Colour[0] === 'Cider'"
                >
                  <use
                    xlink:href="/app/themes/jeroboams-2020/resources/assets/images/apple-alt.svg#apple"
                  />
                </svg>

                <span v-if="result._source.Colour[0] === 'Beer'">
                  {{ result._source.Type }}</span
                >
                <span v-else-if="result._source.Colour[0] === 'Spirit'">
                  {{ result._source.Type }}</span
                >
                <span v-else>
                  {{ result._source.Colour[0] }}
                </span>
              </div>
            </div>
          </div>

          <div class="product-prices">
            <product-format
              :product="result"
              v-if="result._source.DutyAvail !== 'IBOnly'"
            ></product-format>
            <div
              class="product-only-inbond"
              v-if="
                result._source.DutyAvail === 'IBOnly' &&
                result._source.DutyType !== 'DP'
              "
            >
              <a :href="result._source.Permalink">Only available In Bond</a>
            </div>

            <div
              class="mt-1"
              v-if="
                result._source.OtherFormats.length > 0 &&
                !(!formatsLoading && formats[result._id])
              "
            >
              <b-link
                class="small"
                v-if="result._source.OtherFormats.length > 0"
                v-show="!(!formatsLoading && formats[result._id])"
                @click="toggleFormats(result)"
                >{{ result._source.OtherFormats.length }} other
                {{ "option" | inflect(result._source.OtherFormats.length) }}
                available
                <svg
                  v-if="formatsLoading && formats[result._id] === false"
                  class="bi ml-1 spin"
                  width="1rem"
                  height="1rem"
                  fill="currentColor"
                >
                  <use
                    xlink:href="/app/themes/jeroboams-2020/node_modules/bootstrap-icons/bootstrap-icons.svg#arrow-repeat"
                  />
                </svg>
              </b-link>
            </div>

            <div
              v-if="!formatsLoading && formats[result._id]"
              class="mt-2 mt-md-1"
            >
              <product-format
                v-for="format in formats[result._id]"
                v-bind:key="format._id"
                :product="format"
              >
              </product-format>
            </div>
          </div>
        </b-col>
      </b-row>
    </div>
  </b-card>
</template>

<script>
import Config from "@/config/default.config.js";
import ProductFormat from "@/components/ProductFormat";
import WishlistAddButton from "@/components/WishlistAddButton";
import { BadgePlugin } from "bootstrap-vue";
import Vue from "vue";

import Axios from "axios";
Vue.use(BadgePlugin);

export default {
  components: {
    ProductFormat,
    WishlistAddButton,
  },
  data() {
    return {
      formatsLoading: false,
      formats: {},
    };
  },
  props: {
    result: Object,
    filters: Object,
    hide: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    async getFormats(result) {
      var formats = await Axios.get(
        Config.wp.host + "/jbs/v1/get-formats/" + result._source.WCID
      );

      this.formats[result._id] = formats.data;
      for (var i in this.formats[result._id]) {
        this.formats[result._id][i]._source._add_qty = 1;
      }
      this.formatsLoading = false;

      return;
    },
    toggleFormats(result) {
      if (this.formats[result._id]) {
        delete this.formats[result._id];
        this.formatsLoading = false;
        this.$forceUpdate();
      } else {
        this.formats[result._id] = false;
        this.formatsLoading = true;
        this.getFormats(result);
      }
    },
  },
};
</script>